/* eslint-disable @typescript-eslint/no-explicit-any */
import { NgClass } from '@angular/common';
import { Component, OnInit, inject, signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { ActivatedRoute, NavigationEnd, Router, RouterOutlet } from '@angular/router';

import { filter, map, mergeMap } from 'rxjs/operators';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

import { Logger } from '@core/utils';

import { UsuarioService } from '@data/apis';

import { SidebarComponent } from '../../components/sidebar/sidebar.component';
import { HeaderComponent } from '../../components/header/header.component';
import { BreadcrumbComponent } from '../../components/breadcrumb/breadcrumb.component';
import { Menu } from '@data/models';

const log = new Logger('Main');

@UntilDestroy()
@Component({
  selector: 'app-main',
  standalone: true,
  imports: [SidebarComponent, HeaderComponent, BreadcrumbComponent, RouterOutlet, NgClass],
  templateUrl: './main.component.html',
})
export class MainComponent implements OnInit {
  private readonly router = inject(Router);
  private readonly activatedRoute = inject(ActivatedRoute);
  private readonly usuarioService = inject(UsuarioService);

  isSidebarOpen = signal<boolean>(true);
  isBeadcrumb = signal<boolean>(false);
  mobileView = 1536;
  mobile = 600;
  menu = signal<Menu[]>([]);

  pageInfo = toSignal<any>(
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .pipe(map(() => this.activatedRoute))
      .pipe(
        map(route => {
          while (route.firstChild) {
            route = route.firstChild;
          }
          return route;
        })
      )
      .pipe(filter(route => route.outlet === 'primary'))
      .pipe(mergeMap((route: CustomActivatedRoute) => route.data))
  );

  ngOnInit() {
    if (this.getWidth() < this.mobileView) {
      this.isSidebarOpen.set(false);
    }

    if (this.getWidth() < this.mobile) {
      this.isBeadcrumb.set(true);
    }

    this.loadMenu();
  }

  getWidth() {
    return window.innerWidth;
  }

  loadMenu() {
    this.usuarioService
      .loadMenu()
      .pipe(untilDestroyed(this))
      .subscribe((response: { menu: Menu[] }) => {
        log.info('loadMenu', response);
        this.menu.set(response?.menu || []);
      });
  }
}

class CustomActivatedRoute extends ActivatedRoute {
  override data: any;
  override params: any;
}
